import React from 'react';
import { CheckCircle } from 'lucide-react';
export function DairyFarming() {
  return <section id="dairy" className="py-20 bg-white" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-107">
          <div className="w-full lg:w-1/2" data-id="element-108">
            <div className="grid grid-cols-2 gap-4" data-id="element-109">
              <img src="https://images.unsplash.com/photo-1570042225831-d98fa7577f1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Dairy cows" className="rounded-2xl shadow-lg w-full h-64 object-cover transform translate-y-8" data-id="element-110" />
              <img src="https://images.unsplash.com/photo-1527153857715-3908f2bae5e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=721&q=80" alt="Fresh milk" className="rounded-2xl shadow-lg w-full h-64 object-cover" data-id="element-111" />
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-112">
            <div className="inline-block px-4 py-1.5 bg-green-100 text-green-800 font-semibold rounded-full text-sm mb-6" data-id="element-113">
              Core Operations
            </div>
            <h2 className="text-4xl font-bold text-green-900 mb-6" data-id="element-114">
              Premium Dairy Farming
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-115">
              At GreenSlopes Farm, we take pride in our herd. Our cows are
              raised in a stress-free environment, grazing on the lush pastures
              of Nyandarua. We combine traditional care with modern dairy
              practices to ensure the highest quality milk production.
            </p>

            <ul className="space-y-4" data-id="element-116">
              {['High-quality pedigree breeds', 'Automated milking systems for hygiene', 'Regular veterinary care and health monitoring', 'Nutrient-rich diet for optimal milk quality', 'Sustainable waste management'].map((item, index) => <li key={index} className="flex items-start" data-id="element-117">
                  <CheckCircle className="h-6 w-6 text-green-600 mr-3 flex-shrink-0" data-id="element-118" />
                  <span className="text-gray-700 font-medium" data-id="element-119">{item}</span>
                </li>)}
            </ul>

            <div className="mt-10" data-id="element-120">
              <div className="grid grid-cols-3 gap-4 text-center" data-id="element-121">
                <div className="p-4 bg-stone-50 rounded-lg border border-stone-100" data-id="element-122">
                  <div className="text-3xl font-bold text-green-700 mb-1" data-id="element-123">
                    100+
                  </div>
                  <div className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-124">
                    Happy Cows
                  </div>
                </div>
                <div className="p-4 bg-stone-50 rounded-lg border border-stone-100" data-id="element-125">
                  <div className="text-3xl font-bold text-green-700 mb-1" data-id="element-126">
                    High
                  </div>
                  <div className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-127">
                    Butterfat %
                  </div>
                </div>
                <div className="p-4 bg-stone-50 rounded-lg border border-stone-100" data-id="element-128">
                  <div className="text-3xl font-bold text-green-700 mb-1" data-id="element-129">
                    24/7
                  </div>
                  <div className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-130">
                    Care
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}